import { environment } from '@environments/environment';

const noop = (..._args: unknown[]): void => {
  // Intentionally empty.
};

export function configureDebugConsoleLogging(): void {
  if (environment.enableDebugConsoleLogs) {
    return;
  }

  console.log = noop;
  console.debug = noop;
  console.info = noop;
}
